import React from 'react'

import styled from 'styled-components'
import { color } from 'styles/colors'

import { DescriptionAndDetails } from 'types/Alert'

type Props = {
  problems?: Array<DescriptionAndDetails> | null
  possibleCauses?: Array<DescriptionAndDetails> | null
  additionalInfo?: Array<DescriptionAndDetails> | null
  className?: string
}

const Details = ({ possibleCauses = null, problems = null, additionalInfo = null, className = '' }: Props) => {
  return (
    <div className={className}>
      <h4>Problem{(problems?.length ?? 0) > 1 ? 's' : ''}:</h4>
      <S.List itemsCount={problems?.length ?? 0}>
        {problems
          ? problems.map(({ description, details }) =>
            (
              <div key={description}>
                <S.Li>{description}</S.Li>
                {details && <S.DetailsList> {details.map(detail => <S.Li key={detail}>{detail}</S.Li>)}</S.DetailsList>}
              </div>
            )
          )
          : '--'}
      </S.List>

      <h4>Possible Cause{(possibleCauses?.length ?? 0) > 1 ? 's' : ''} & Solutions:</h4>
      <S.List itemsCount={possibleCauses?.length ?? 0}>
        {possibleCauses
          ? possibleCauses.map(({ description, details }) =>
            (
              <div key={description}>
                <S.Li>{description}</S.Li>
                {details && <S.DetailsList> {details.map(detail => <S.Li key={detail}>{detail}</S.Li>)}</S.DetailsList>}
              </div>
            )
          )
          : '--'
        }
      </S.List>

      {additionalInfo &&
        <>
          <h4>Additional Information:</h4>
          <S.List itemsCount={additionalInfo?.length ?? 0}>
            {additionalInfo.map(({ description, details }) =>
              (
                <div key={description}>
                  <S.Li>{description}</S.Li>
                  {details && <S.DetailsList> {details.map(detail => <S.Li key={detail}>{detail}</S.Li>)}</S.DetailsList>}
                </div>
              )
            )}
          </S.List>
        </>
        }
    </div>
  )
}

export default Details

const S = {
  List: styled.ul.withConfig({
    shouldForwardProp: (prop) => !['itemsCount'].includes(prop)
  })<{ itemsCount: number }>`
    list-style-type: ${({ itemsCount }) => itemsCount > 1 ? 'disc' : 'none'};
    list-style-position: inside;
    color: ${color('tooltipText')};
    padding-bottom: 10px;
    padding-left: 20px;
    margin: 0;
  `,
  DetailsList: styled.ul`
    list-style-position: inside;
  `,
  Li: styled.li`
    color: ${color('tooltipText')};
  `
}
